// Single source of truth for "is this product on the website?".
//
// The `products` collection is shared with the POS/inventory system, so it
// holds far more items than we ever want on the storefront. `active` means
// "active in inventory" and defaults to true for POS-created items — it can't
// double as the storefront gate.
//
// `webActive` is an explicit, opt-in publish flag set from admin → Products.
// Only products with webActive === true appear on the storefront, in the
// sitemap, and in the Google Merchant Center feed. Everything else stays
// in-store only. A missing field means "not published" on purpose: nothing
// leaks online until an admin says so.

export function isWebProduct(p) {
  return !!p && p.webActive === true;
}

export function filterWebProducts(list) {
  return (Array.isArray(list) ? list : []).filter(isWebProduct);
}

// How many photos of a product we actually render on the product page.
// Some products carry 50–100 variant photos; showing them all makes the page
// unusable (and impossible to keep uploaded/current), so we show the first N
// and point shoppers at WhatsApp for the rest. Editable in admin → Site
// Content → "More styles on WhatsApp".
export const DEFAULT_GALLERY_LIMIT = 12;

export function galleryLimit(content) {
  const n = Number(content?.variants?.galleryLimit);
  if (!Number.isFinite(n) || n <= 0) return DEFAULT_GALLERY_LIMIT;
  return Math.min(100, Math.max(1, Math.round(n)));
}
